import { Popover, PopoverButton, PopoverPanel } from '@headlessui/react';
import TargetAudienceSelector, {
  TargetAudienceSelectorProps,
} from './target-audience-selector';
import classNames from 'classnames';
import { ReactNode, useState } from 'react';
import Button from '../button/button';
import { useTranslation } from 'react-i18next';
import OutsideClickHandler from 'react-outside-click-handler';

export interface TargetAudienceSelectorPopoverProps
  extends TargetAudienceSelectorProps {
  popoverButtonContents: ReactNode;
  position?: 'right' | 'left' | 'top' | 'bottom' | 'center';
  onCancel: () => void;
  canSave?: boolean;
}

export const TargetAudienceSelectorPopover = ({
  popoverButtonContents,
  onCancel,
  canSave = true,
  ...rest
}: TargetAudienceSelectorPopoverProps) => {
  const [isOpen, setIsOpen] = useState(false);
  const { t } = useTranslation(['common']);
  return (
    <Popover className="relative">
      <PopoverButton
        as="div"
        className="inline-flex items-center gap-x-1 text-sm/6 font-semibold text-gray-900 w-full"
        onClick={() => setIsOpen(!isOpen)}
      >
        {popoverButtonContents}
      </PopoverButton>

      {isOpen && (
        <div className="fixed top-0 left-0 w-screen h-screen z-10">
          <PopoverPanel
            portal
            static
            transition
            className={classNames(
              'fixed z-10 mt-5 flex w-screen max-w-max px-4 transition data-closed:opacity-0 data-enter:duration-200 data-enter:ease-out data-leave:duration-150 data-leave:ease-in top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2'
            )}
          >
            <OutsideClickHandler onOutsideClick={() => setIsOpen(false)}>
              <div className="w-screen max-w-md flex-auto overflow-auto rounded-3xl bg-white text-sm/6 ring-1 shadow-lg ring-gray-900/5 lg:max-w-3xl">
                <div className="p-4 h-[75vh] overflow-auto">
                  <TargetAudienceSelector {...rest} />
                  <div className="flex justify-end mt-4 space-x-2">
                    <Button
                      type="button"
                      variant="primary"
                      disabled={!canSave}
                      onClick={() => {
                        setIsOpen(false);
                      }}
                    >
                      {t('Ok')}
                    </Button>
                  </div>
                </div>
              </div>
            </OutsideClickHandler>
          </PopoverPanel>
        </div>
      )}
    </Popover>
  );
};
